// RefusedList.js
import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Container, Typography, Alert, Avatar, Chip, Box, Stack
} from "@mui/material";

const getInitials = (prenom, nom) =>
  `${prenom ? prenom[0] : ""}${nom ? nom[0] : ""}`.toUpperCase();

const StatusChip = ({ statut }) => (
  <Chip
    label={statut.charAt(0).toUpperCase() + statut.slice(1)}
    style={{
      background: "#ffeaea",
      color: "#ff3b3b",
      fontWeight: 700,
      border: "1.2px solid #ff3b3b"
    }}
    size="small"
  />
);

function RefusedList() {
  const [demandes, setDemandes] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchDemandes = async () => {
      try {
        const token = localStorage.getItem("accessToken");
        if (!token) {
          setError("Utilisateur non authentifié");
          return;
        }
        const response = await axios.get("https://appapi.unpaidfinancial.com/api/demandes", {
          headers: { Authorization: `Bearer ${token}` },
        });
        // On ne garde que les refusées/rejetées
        setDemandes(response.data.filter(d =>
          /refus|rej/i.test(d.statut)
        ));
      } catch (err) {
        setError("Erreur lors de la récupération des demandes");
      }
    };
    fetchDemandes();
  }, []);

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Typography variant="h4" sx={{ fontWeight: 800, mb: 4, textAlign: "center" }}>
        Demandes rejetées
      </Typography>
      {error && <Alert severity="error">{error}</Alert>}
      {demandes.length === 0 && !error && (
        <Alert severity="info" sx={{ mt: 3, textAlign: "center" }}>
          Aucune demande rejetée pour le moment.
        </Alert>
      )}
      <Stack spacing={3} sx={{ mt: 4 }}>
        {demandes.map((demande) => (
          <Stack direction="row" spacing={2} alignItems="flex-start" key={demande.id}>
            <Avatar sx={{
              bgcolor: "#ff3b3b",
              color: "#fff",
              fontWeight: 700,
              width: 48,
              height: 48,
              border: "2.5px solid #fff",
              boxShadow: "0 3px 8px rgba(255,59,59,0.13)",
            }}>
              {getInitials(demande.prenom, demande.nom)}
            </Avatar>
            <Box sx={{
              background: "#ffeaea",
              borderRadius: 3,
              p: 2.1,
              boxShadow: "0 2px 10px 0 rgba(255,59,59,0.07)",
              minWidth: 0,
              flexGrow: 1
            }}>
              <Stack direction="row" alignItems="center" spacing={1}>
                <Typography variant="h6" sx={{ fontWeight: 700, color: "#ab1c1c" }}>
                  {demande.nom} {demande.prenom}
                </Typography>
                <StatusChip statut={demande.statut} />
              </Stack>
              <Typography variant="body2" sx={{ color: "#d14242", mt: 0.5 }}>
                {demande.email} {demande.telephone && `| ${demande.telephone}`}
              </Typography>
              <Typography variant="body2" sx={{ color: "#ab1c1c", mt: 0.5 }}>
                                <strong>Sexe :</strong> {demande.sexe}
                              </Typography>

                              <Typography variant="body2" sx={{ color: "#ab1c1c", mt: 0.5 }}>
                                <strong>Date de Naissance :</strong> {demande.dateNaissance}
                              </Typography>
              
                              <Typography variant="body2" sx={{ color: "#ab1c1c", mt: 0.5 }}>
                                <strong>Type d'Aide :</strong> {demande.typeAide}
                              </Typography>
              
                              <Typography variant="body2" sx={{ color: "#ab1c1c", mt: 0.5 }}>
                                <strong>Adresse résidentielle :</strong> {demande.adresse}
                              </Typography>
              {demande.montantDemande &&
                <Typography variant="body2" sx={{ color: "#ab1c1c", mt: 0.5 }}>
                  <strong>Montant : </strong>{demande.montantDemande} {demande.devise}
                </Typography>
              }
              {demande.ville || demande.pays ? (
                <Typography variant="body2" sx={{ color: "#ba2222", mt: 0.5 }}>
                  <strong>Lieu : </strong>{demande.ville} {demande.pays && `, ${demande.pays}`}
                </Typography>
              ) : null}
              {demande.projetDescription && (
                <Typography variant="body2" sx={{ color: "#a02e2e", mt: 0.5 }}>
                  <strong>Projet :</strong> {demande.projetDescription}
                </Typography>
              )}
            </Box>
          </Stack>
        ))}
      </Stack>
    </Container>
  );
}
export default RefusedList;
